<ng-container *transloco="let t; read: 'ime.manufacturing.manufacturing-item-or-group-select'">
  <div *ngIf="(allItems$ | async) as allItems; else loading">
    <ng-select #select class="select-sm" [items]="allItems" [name]="name" [ngModel]="multiple ? entityIds : entityId" (ngModelChange)="multiple ? entityIds : entityId = $event" [virtualScroll]="true" [searchFn]="searchFn"
               bindLabel="DisplayName" (change)="onSelectionChanged($event); select.close()" [multiple]="multiple" bindValue="Id" appendTo="body" [disabled]="readonly">
      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{select: select, item: item, index: index, searchTerm: search}">
        </ng-container>
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        <span class="ng-value-label">
          {{item | displayName}}
        </span>
        <span *ngIf="item.StatusClv === Classificators.ItemStatus.Draft" class="badge bg-default" title="{{t('Draft')}}">D</span>
      </ng-template>
      <ng-template ng-footer-tmp>
        <ng-container [ngTemplateOutlet]="footer" [ngTemplateOutletContext]="{select: select}">
        </ng-container>
      </ng-template>
      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <ng-container [ngTemplateOutlet]="notfound"
                      [ngTemplateOutletContext]="{select: select, searchTerm: searchTerm}">
        </ng-container>
      </ng-template>
    </ng-select>
  </div>

  <ng-template #loading>{{t('Loading')}}...</ng-template>

  <ng-template #itemTemplate let-searchTerm="searchTerm" let-select="select" let-item="item">
    <div class="d-flex justify-content-between text-wrap text-break ms-n1 bl-3" [ngClass]="item.ItemGroupId === undefined ? 'border-primary' : 'border-secondary'">
      <span>
        <span [ngOptionHighlight]="searchTerm">
        {{item | displayName}}
      </span>
      <span *ngIf="item.StatusClv === Classificators.ItemStatus.Draft" class="badge bg-default" title="{{t('Draft')}}">D</span>
      </span>
      <a href="{{item.ItemGroupId === undefined ? '/manufacturing/item-template/edit/' + item.Id : '/manufacturing/item/edit/' + item.Id}}" target="_blank" class="show-on-option-hover my-auto me-1" (click)="$event.stopPropagation()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-top-right-on-square"></svg>
      </a>
    </div>
  </ng-template>

  <ng-template #notfound let-searchTerm="searchTerm" let-select="select">
    <div class="ng-option disabled">
      <ng-container *ngIf="allowItemGroups">
        <button class="btn btn-sm btn-outline-primary me-1" *ngIf="enableGroupAdd" (click)="select.close(); addNewGroup(searchTerm)">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
          {{t('Add group')}} "{{searchTerm}}"
        </button>
      </ng-container>
      <button class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNewItem(searchTerm)">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        {{t('Add item')}} "{{searchTerm}}"
      </button>
    </div>
  </ng-template>

  <ng-template #footer let-select="select">
    <div class="d-flex w-100" mesStopClickPropagation>
      <div class="dropdown" ngbDropdown *ngIf="allowItemGroups">
        <button class="dropdown-toggle btn btn-outline-primary" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#ellipsis-horizontal"></svg>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <button class="dropdown-item" ngbDropdownItem [class.active]="showGroups" (click)="showGroups = !showGroups; ensureItems()">{{t('Group')}}</button>
          <button class="dropdown-item" ngbDropdownItem [class.active]="showItems" (click)="showItems = !showItems; ensureItems()">{{t('Item')}}</button>
        </div>
      </div>
      <div class="dropdown ms-auto" ngbDropdown>
        <button class="dropdown-toggle btn btn-outline-primary" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <button class="dropdown-item" ngbDropdownItem *ngIf="enableGroupAdd && allowItemGroups" (click)="select.close(); addNewGroup()">{{t('Group')}}</button>
          <button class="dropdown-item" ngbDropdownItem (click)="select.close(); addNewItem()">{{t('Item')}}</button>
        </div>
      </div>
      <ng-container *ngIf="entityId">
        <button *ngIf="allItems$ | async | find: ['Id']: entityId as item" class="btn btn-sm btn-outline-primary ms-auto" (click)="select.close(); editExisting(item)">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
        </button>
      </ng-container>
      <ng-container *ngIf="entityIds?.length">
        <button *ngIf="allItems$ | async | find: ['Id']: entityIds[0] as item" class="btn btn-sm btn-outline-primary ms-auto" (click)="select.close(); editExisting(item)">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
        </button>
      </ng-container>
    </div>
  </ng-template>
</ng-container>
